export const CREATE_NOTIFICATION_REQUEST = "CREATE_NOTIFICATION_NOTIFICATION_REQUEST"
export const CREATE_NOTIFICATION_REQUEST_SUCCESS = "CREATE_NOTIFICATION_NOTIFICATION_REQUEST_SUCCESS"

